import store from "@/store";
import { SERVICE_TYPE } from "@/constants/ServiceTypes";
import { calculatePayoutForDate } from "@/utils/GradeResolver";
export default class Instructor {
    id = '';
    data = {
        name: '',
        surname: '',
        email: '',
        phone: null,
        grade_id: null,
        role: 0,
        notifications: [],
        image: null,
        bankAccount: '',
        balance: 0,
        paysTaxes: false,
    };
    constructor(data) {
        Object.assign(this, data);
    }
    toString() {
        return `${this.data.name} ${this.data.surname}`;
    }
    ;
    /**
     * Calculate payout for an instructor's work.
     *
     * @param lessonType - 'individual' | 'wex' | 'kidSchool' | 'storno'
     * @param lessonLength - Number of hours
     * @param date - Optional date for historical grade rate lookup
     * @returns Payout amount in CZK
     */
    calculatePayout(lessonType, lessonLength, date) {
        // Normalize lesson type for kid school
        const normalizedLessonType = lessonType === SERVICE_TYPE.KID_SCHOOL ? 'kidSchool' : lessonType;
        // If date provided, use date-aware lookup via GradeResolver
        if (date) {
            return calculatePayoutForDate(this, normalizedLessonType, lessonLength, date);
        }
        // Fallback to current behavior for backward compatibility
        const grade = store.getters['grade/all'].find((grade) => grade.id === store.getters['instructor/get'](this.id).data.grade_id);
        if (!grade) {
            throw new Error('Nebyla nalezena platová třída pro instruktora!');
        }
        return grade.data[normalizedLessonType] * lessonLength;
    }
}
